interface LogoProps {
  size?: number
}

export function CXAdminMark({ size = 42 }: LogoProps) {
  return (
    <img
      src="/assets/cx-admin-mark.png"
      alt=""
      width={size}
      height={size}
      style={{ width: size, height: size, objectFit: 'contain', flexShrink: 0 }}
    />
  )
}

export function CXAdminWordmark({ size = 42 }: LogoProps) {
  return (
    <div style={{ display: 'inline-flex', alignItems: 'center', gap: 11 }}>
      <CXAdminMark size={size} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <span style={{
          fontSize: Math.max(17, size * 0.48),
          lineHeight: 1.05,
          color: 'var(--ink)',
          letterSpacing: '-0.035em',
          fontWeight: 700,
          whiteSpace: 'nowrap',
        }}>
          CX Admin
        </span>
        <span style={{ color: 'var(--ink-3)', fontSize: 11.5, whiteSpace: 'nowrap' }}>
          Powered by Helix
        </span>
      </div>
    </div>
  )
}

// Compatibility exports keep existing imports stable for downstream code.
export const HelixMark = CXAdminMark
export const HelixWordmark = CXAdminWordmark

interface AvatarProps {
  name?: string
  size?: number
  gradient?: boolean
}

export function Avatar({ name = 'A', size = 28, gradient = false }: AvatarProps) {
  const initials = name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()
  return (
    <div style={{
      width: size,
      height: size,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gradient ? 'linear-gradient(145deg, #edf3ff, #dce7f7)' : 'var(--bg-sunken)',
      color: 'var(--ink)',
      border: '1px solid var(--line)',
      fontSize: size * 0.4,
      fontWeight: 600,
      letterSpacing: '-0.02em',
      flexShrink: 0,
    }}>
      {initials}
    </div>
  )
}
